import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useGoogleMapsStaticMap } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { getDirectionsUrl } from '@grandvisionhq/utils';
import { storeDetailsEvent } from '../../data-layer/actions.js';
import StoreLocation from './StoreLocation.js';

const StoreLocationContainer = (_param)=>{
    var { opco , globalStoreId , name , town , country , streetName , streetNumber , additionalStreetInfo , postalCode , province , lat , lon  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "opco",
        "globalStoreId",
        "name",
        "town",
        "country",
        "streetName",
        "streetNumber",
        "additionalStreetInfo",
        "postalCode",
        "province",
        "lat",
        "lon"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('stores.page.details.location.title'),
            getDirections: getLabel('stores.page.details.action.getDirections'),
            practicalInformationTitle: getLabel('stores.page.details.practicalInformation.title'),
            address: getLabel('stores.page.details.location.address')
        })
    , [
        getLabel
    ]);
    const addressData = React.useMemo(()=>({
            storeName: name,
            streetName,
            streetNumber,
            additionalStreetInfo,
            postalCode,
            town,
            province
        })
    , [
        name,
        streetName,
        streetNumber,
        additionalStreetInfo,
        postalCode,
        town,
        province
    ]);
    const mapImageUrl = useGoogleMapsStaticMap({
        lat,
        lon
    });
    const directionsUrl = getDirectionsUrl({
        streetName,
        town,
        opco
    });
    const onGetDirectionsClick = React.useCallback(()=>{
        const dataLayerEvent = storeDetailsEvent({
            interaction: 'get directions click',
            store: {
                globalStoreId,
                name,
                town,
                country,
                streetName,
                streetNumber,
                additionalStreetInfo,
                postalCode
            }
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, [
        globalStoreId,
        name,
        town,
        country,
        streetName,
        streetNumber,
        additionalStreetInfo,
        postalCode, 
    ]);
    return /*#__PURE__*/ React.createElement(StoreLocation, swcHelpers.extends({}, rest, {
        labels: labels,
        addressSize: "LARGE",
        addressData: addressData,
        mapImageUrl: mapImageUrl,
        directionsUrl: directionsUrl,
        onGetDirectionsClick: onGetDirectionsClick
    }));
};

export { StoreLocationContainer as default };
//# sourceMappingURL=StoreLocationContainer.js.map
